// extracted by mini-css-extract-plugin
export default {"treeArea":"EntityTree_treeArea__nzQhW","treeBox":"EntityTree_treeBox__YIP-v"};